import React from "react";
import AdminHomeView from "../../../views/adminArea/adminHomeViews/AdminHomeView";

function AdminHome() {
    return (<AdminHomeView/>)
}

export default AdminHome;